"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2427],{

/***/ 96661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H$": function() { return /* binding */ WrappedTokensFlowContext; },
/* harmony export */   "hf": function() { return /* binding */ WrapperTokensFlowProvider; }
/* harmony export */ });
/* unused harmony export initValue */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_use_balances__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68203);
/* harmony import */ var _hooks_use_deposit_token_options__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74733);




const initValue = {
    selectedToken: null,
    setSelectedToken: ()=>null,
    prevTokenBalance: 0,
    tokenOptions: []
};
const WrappedTokensFlowContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(initValue);
const WrapperTokensFlowProvider = (param)=>{
    let { children  } = param;
    const { balances  } = (0,_hooks_use_balances__WEBPACK_IMPORTED_MODULE_2__/* .useBalances */ .l)();
    const [selectedToken, setSelectedToken] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const { tokenOptions  } = (0,_hooks_use_deposit_token_options__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const prevTokenBalance = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!selectedToken) return 0;
        return balances[selectedToken.symbol] || 0;
    // store the previous balance based on the selectedToken, no need update when the balances are changed
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedToken
    ]);
    const ctxValue = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>({
            selectedToken,
            setSelectedToken,
            prevTokenBalance,
            tokenOptions
        }), [
        selectedToken,
        prevTokenBalance,
        tokenOptions
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedTokensFlowContext.Provider, {
        value: ctxValue,
        children: children
    });
};


/***/ }),

/***/ 90804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ SwapOrderbookContext; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _solana_web3_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27632);
/* harmony import */ var _trathailoi_phoenix_orderbook_sdk__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86439);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18446);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _components_home_context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5144);
/* harmony import */ var _components_limit_order_hooks_use_fetch_all_markets__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98638);
/* harmony import */ var _components_limit_order_hooks_use_fetch_market_info__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79868);
/* harmony import */ var _hooks_use_settings__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49472);
/* harmony import */ var _hooks_use_tokens__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(28309);
/* eslint-disable no-console */ 









const initContextState = {
    isFetchingMarketInfo: false,
    refetchMarketInfo: ()=>Promise.resolve()
};
const SwapOrderbookContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.createContext)(initContextState);
const SwapOrderbookProvider = (param)=>{
    let { children  } = param;
    const { data: settingsData  } = (0,_hooks_use_settings__WEBPACK_IMPORTED_MODULE_8__/* .useSettings */ .r)();
    const enabledSwapOrderbook = Boolean(settingsData === null || settingsData === void 0 ? void 0 : settingsData.swap_and_orderbook_router_feature_enabled);
    const { tokenIn: uiTokenIn , tokenOut: uiTokenOut  } = (0,react__WEBPACK_IMPORTED_MODULE_4__.useContext)(_components_home_context__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP);
    const { tokenListMap  } = (0,_hooks_use_tokens__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Co)(true);
    const { data: markets  } = (0,_components_limit_order_hooks_use_fetch_all_markets__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(enabledSwapOrderbook);
    const marketAddress = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(()=>{
        if (!markets) return;
        const market = markets.find((param)=>{
            let { base_token_mint_address , quote_token_mint_address  } = param;
            return lodash_isEqual__WEBPACK_IMPORTED_MODULE_3___default()([
                base_token_mint_address,
                quote_token_mint_address
            ].sort(), [
                uiTokenIn === null || uiTokenIn === void 0 ? void 0 : uiTokenIn.address,
                uiTokenOut === null || uiTokenOut === void 0 ? void 0 : uiTokenOut.address
            ].sort());
        });
        if (!market) return;
        return new _solana_web3_js__WEBPACK_IMPORTED_MODULE_1__.PublicKey(market.market_address);
    }, [
        markets,
        uiTokenIn === null || uiTokenIn === void 0 ? void 0 : uiTokenIn.address,
        uiTokenOut === null || uiTokenOut === void 0 ? void 0 : uiTokenOut.address
    ]);
    const { data: marketInfo , isFetching: isFetchingMarketInfo , refetch: refetchMarketInfo  } = (0,_components_limit_order_hooks_use_fetch_market_info__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(marketAddress, enabledSwapOrderbook);
    const [baseToken] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(()=>{
        return [
            (marketInfo === null || marketInfo === void 0 ? void 0 : marketInfo.baseTokenMintAddress) && tokenListMap.get(marketInfo.baseTokenMintAddress.toBase58()),
            (marketInfo === null || marketInfo === void 0 ? void 0 : marketInfo.quoteTokenMintAddress) && tokenListMap.get(marketInfo.quoteTokenMintAddress.toBase58())
        ];
    }, [
        marketInfo,
        tokenListMap
    ]);
    const priceLadder = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(()=>{
        var _marketInfo_marketState;
        return marketInfo === null || marketInfo === void 0 ? void 0 : (_marketInfo_marketState = marketInfo.marketState) === null || _marketInfo_marketState === void 0 ? void 0 : _marketInfo_marketState.getUiLadder();
    }, [
        marketInfo === null || marketInfo === void 0 ? void 0 : marketInfo.marketState
    ]);
    const orderbookSide = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(()=>{
        if (!uiTokenIn || !baseToken) return;
        return uiTokenIn.address === baseToken.address ? _trathailoi_phoenix_orderbook_sdk__WEBPACK_IMPORTED_MODULE_2__/* .Side.Ask */ .MFA.Ask : _trathailoi_phoenix_orderbook_sdk__WEBPACK_IMPORTED_MODULE_2__/* .Side.Bid */ .MFA.Bid;
    }, [
        uiTokenIn,
        baseToken
    ]);
    const value = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(()=>{
        return {
            marketAddress,
            priceLadder,
            marketInfo,
            isFetchingMarketInfo,
            refetchMarketInfo: async ()=>{
                await refetchMarketInfo();
            },
            orderbookSide
        };
    }, [
        marketAddress,
        orderbookSide,
        priceLadder,
        marketInfo,
        refetchMarketInfo,
        isFetchingMarketInfo
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SwapOrderbookContext.Provider, {
        value: value,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SwapOrderbookProvider);


/***/ }),

/***/ 5144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "sd": function() { return /* binding */ SwapProvider; }
/* harmony export */ });
/* unused harmony export defaultTokenInfoB */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_use_amplitude__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54341);
/* harmony import */ var _hooks_use_settings__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49472);
/* harmony import */ var _hooks_use_tokens__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28309);
/* harmony import */ var _providers_language__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1877);
/* harmony import */ var _use_token_mint_addresses__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52988);







const defaultTokenInfoA = {
    nickName: "tokenA",
    chainId: 101,
    address: _hooks_use_tokens__WEBPACK_IMPORTED_MODULE_4__/* .RENEC_MINT_ADDRESS */ .vV,
    name: _hooks_use_tokens__WEBPACK_IMPORTED_MODULE_4__/* .RENEC */ .A7,
    decimals: 9,
    symbol: _hooks_use_tokens__WEBPACK_IMPORTED_MODULE_4__/* .RENEC */ .A7,
    logoURI: "https://remitano.com/coins/renec.png"
};
const defaultTokenInfoB = {
    nickName: "tokenA",
    chainId: 101,
    address: _hooks_use_tokens__WEBPACK_IMPORTED_MODULE_4__/* .REUSD_MINT_ADDRESS */ .Df,
    name: _hooks_use_tokens__WEBPACK_IMPORTED_MODULE_4__/* .REUSD */ .ZP,
    decimals: 9,
    symbol: _hooks_use_tokens__WEBPACK_IMPORTED_MODULE_4__/* .REUSD */ .ZP,
    logoURI: "https://raw.githubusercontent.com/renec-chain/rpl-token-registry/master/assets/mainnet/4Q89182juiadeFgGw3fupnrwnnDmBhf7e7fHWxnUP3S3/logo.png"
};
const initContextState = {
    inputMintAddress: _hooks_use_tokens__WEBPACK_IMPORTED_MODULE_4__/* .REUSD */ .ZP,
    setInputMintAddress: ()=>null,
    outputMintAddress: _hooks_use_tokens__WEBPACK_IMPORTED_MODULE_4__/* .REUSD */ .ZP,
    setOutputMintAddress: ()=>null,
    switchMintAddresses: ()=>null,
    tokenIn: defaultTokenInfoA,
    tokenOut: defaultTokenInfoB,
    isLoading: false
};
const SwapContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(initContextState);
const DEFAULT_MINT_ADDRESSES_BY_LANG_MAP = {
    vi: [
        "",
        _hooks_use_tokens__WEBPACK_IMPORTED_MODULE_4__/* .REVND_MINT_ADDRESS */ .PW
    ],
    vn: [
        "",
        _hooks_use_tokens__WEBPACK_IMPORTED_MODULE_4__/* .REVND_MINT_ADDRESS */ .PW
    ],
    ng: [
        "",
        _hooks_use_tokens__WEBPACK_IMPORTED_MODULE_4__/* .RENGN_MINT_ADDRESS */ .f_
    ],
    en: [
        "",
        _hooks_use_tokens__WEBPACK_IMPORTED_MODULE_4__/* .RENEC_MINT_ADDRESS */ .vV
    ]
};
const SwapProvider = (param)=>{
    let { children  } = param;
    const { isLoading: isLoadingSettings  } = (0,_hooks_use_settings__WEBPACK_IMPORTED_MODULE_3__/* .useSettings */ .r)();
    const { getTokenInfo , isLoading: isLoadingTokens  } = (0,_hooks_use_tokens__WEBPACK_IMPORTED_MODULE_4__/* .useTokens */ .rU)();
    const amplitude = (0,_hooks_use_amplitude__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    const { isoCode  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_providers_language__WEBPACK_IMPORTED_MODULE_5__/* .LanguageContext */ .A);
    var _DEFAULT_MINT_ADDRESSES_BY_LANG_MAP_;
    const initMintAddresses = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return (_DEFAULT_MINT_ADDRESSES_BY_LANG_MAP_ = DEFAULT_MINT_ADDRESSES_BY_LANG_MAP[(isoCode === null || isoCode === void 0 ? void 0 : isoCode.toLowerCase()) || "en"]) !== null && _DEFAULT_MINT_ADDRESSES_BY_LANG_MAP_ !== void 0 ? _DEFAULT_MINT_ADDRESSES_BY_LANG_MAP_ : DEFAULT_MINT_ADDRESSES_BY_LANG_MAP["en"];
    }, [
        isoCode
    ]);
    const { mintAddresses , setMintAddresses  } = (0,_use_token_mint_addresses__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(initMintAddresses);
    const [inputMintAddress, outputMintAddress] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>mintAddresses, [
        mintAddresses
    ]);
    const [tokenIn, tokenOut] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>[
            inputMintAddress ? getTokenInfo(inputMintAddress) : undefined,
            outputMintAddress ? getTokenInfo(outputMintAddress) : undefined
        ], [
        getTokenInfo,
        inputMintAddress,
        outputMintAddress
    ]);
    const switchMintAddresses = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        amplitude.track(_hooks_use_amplitude__WEBPACK_IMPORTED_MODULE_2__/* .EVENT_NAMES.swap_switch_token */ .K.swap_switch_token, {
            from_token: tokenOut === null || tokenOut === void 0 ? void 0 : tokenOut.symbol,
            to_token: tokenIn === null || tokenIn === void 0 ? void 0 : tokenIn.symbol
        });
        setMintAddresses((param)=>{
            let [a, b] = param;
            return [
                b,
                a
            ];
        });
    }, [
        amplitude,
        tokenIn,
        tokenOut,
        setMintAddresses
    ]);
    const setInputMintAddress = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((mintAddress)=>{
        setMintAddresses((param)=>{
            let [a, b] = param;
            return [
                mintAddress,
                mintAddress === b ? a : b
            ];
        });
        const token = getTokenInfo(mintAddress);
        amplitude.track(_hooks_use_amplitude__WEBPACK_IMPORTED_MODULE_2__/* .EVENT_NAMES.swap_select_from_token */ .K.swap_select_from_token, {
            token_name: token === null || token === void 0 ? void 0 : token.symbol
        });
    }, [
        amplitude,
        getTokenInfo,
        setMintAddresses
    ]);
    const setOutputMintAddress = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((mintAddress)=>{
        setMintAddresses((param)=>{
            let [a, b] = param;
            return [
                mintAddress === a ? b : a,
                mintAddress
            ];
        });
        const token = getTokenInfo(mintAddress);
        amplitude.track(_hooks_use_amplitude__WEBPACK_IMPORTED_MODULE_2__/* .EVENT_NAMES.swap_select_to_token */ .K.swap_select_to_token, {
            token_name: token === null || token === void 0 ? void 0 : token.symbol
        });
    }, [
        amplitude,
        getTokenInfo,
        setMintAddresses
    ]);
    const contextValue = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return {
            inputMintAddress,
            setInputMintAddress,
            outputMintAddress,
            setOutputMintAddress,
            switchMintAddresses,
            tokenIn,
            tokenOut,
            isLoading: isLoadingSettings || isLoadingTokens
        };
    }, [
        inputMintAddress,
        setInputMintAddress,
        outputMintAddress,
        setOutputMintAddress,
        switchMintAddresses,
        tokenIn,
        tokenOut,
        isLoadingSettings,
        isLoadingTokens
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SwapContext.Provider, {
        value: contextValue,
        children: children
    });
};
SwapContext.displayName = "SwapContext";
/* harmony default export */ __webpack_exports__["ZP"] = (SwapContext);


/***/ }),

/***/ 52988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18446);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _hooks_use_tokens__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28309);




const PAIR_SEPARATOR = "_";
const useTokenMintAddresses = (initMintAddresses)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const { isLoading , tokenList  } = (0,_hooks_use_tokens__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Co)();
    const [defaultMintAddresses, setDefaultMintAddresses] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(initMintAddresses);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        setDefaultMintAddresses((defaultMintAddresses)=>lodash_isEqual__WEBPACK_IMPORTED_MODULE_0___default()(defaultMintAddresses, initMintAddresses) ? defaultMintAddresses : initMintAddresses);
    }, [
        initMintAddresses
    ]);
    const [mintAddresses, setMintAddresses] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([
        "",
        ""
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (isLoading || !tokenList) return;
        const queryPair = String(window.location.pathname.split("/").pop()).toLowerCase();
        const pairs = queryPair.split(PAIR_SEPARATOR);
        if (pairs.length < 1 || pairs.length > 2) return;
        let foundTokenIn;
        let foundTokenOut;
        if (pairs.length === 1) {
            // if only one token in the query string, treat it as tokenOut
            foundTokenOut = tokenList.find((t)=>t.token_symbol.toLowerCase() === pairs[0]);
            if (!foundTokenOut) return;
        } else {
            foundTokenIn = tokenList.find((t)=>t.token_symbol.toLowerCase() === pairs[0]);
            foundTokenOut = tokenList.find((t)=>t.token_symbol.toLowerCase() === pairs[1]);
            if (!foundTokenIn || !foundTokenOut) return;
        }
        setMintAddresses((mintAddresses)=>{
            const [prevInAddr, prevOutAddr] = mintAddresses;
            const newDefaultInAddr = (foundTokenIn === null || foundTokenIn === void 0 ? void 0 : foundTokenIn.coin_address) || prevInAddr;
            const newDefaultOutAddr = (foundTokenOut === null || foundTokenOut === void 0 ? void 0 : foundTokenOut.coin_address) || prevOutAddr;
            const newAddr = newDefaultInAddr === newDefaultOutAddr ? [
                "",
                newDefaultOutAddr
            ] : [
                newDefaultInAddr,
                newDefaultOutAddr
            ];
            return lodash_isEqual__WEBPACK_IMPORTED_MODULE_0___default()(newAddr, mintAddresses) ? mintAddresses : newAddr;
        });
    }, [
        isLoading,
        tokenList
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (![
            "/swap",
            "/swap/[pair]",
            "/limit/[pair]"
        ].includes(router.pathname)) return;
        if (isLoading || !tokenList) return;
        const tokenIn = tokenList.find((t)=>t.coin_address === mintAddresses[0]);
        const tokenOut = tokenList.find((t)=>t.coin_address === mintAddresses[1]);
        if (tokenIn && !tokenOut) return;
        const newPairQuery = [
            tokenIn === null || tokenIn === void 0 ? void 0 : tokenIn.token_symbol,
            tokenOut === null || tokenOut === void 0 ? void 0 : tokenOut.token_symbol
        ].filter(Boolean).join(PAIR_SEPARATOR);
        if (!newPairQuery) return;
        const searchParams = window.location.search;
        const pathname = router.pathname === "/swap" ? "/swap/[pair]" : router.pathname;
        window.history.replaceState({}, "", "".concat(pathname.replace("[pair]", newPairQuery)).concat(searchParams));
    }, [
        isLoading,
        mintAddresses,
        router,
        tokenList
    ]);
    const finalMintAddresses = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>mintAddresses[0] || mintAddresses[1] ? mintAddresses : defaultMintAddresses, [
        defaultMintAddresses,
        mintAddresses
    ]);
    const handleSetMintAddresses = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((updater)=>{
        setMintAddresses(typeof updater === "function" ? updater(finalMintAddresses) : updater);
    }, [
        finalMintAddresses
    ]);
    return {
        mintAddresses: finalMintAddresses,
        setMintAddresses: handleSetMintAddresses
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useTokenMintAddresses);


/***/ }),

/***/ 98638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88767);
/* harmony import */ var _hooks_use_settings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49472);
/* harmony import */ var _root_cypress_fixtures_orderbook_markets_json__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2425);
/* harmony import */ var _utils_apis_orderbook__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26110);




const useFetchAllMarkets = (enabled)=>{
    const { data: settingsData  } = (0,_hooks_use_settings__WEBPACK_IMPORTED_MODULE_1__/* .useSettings */ .r)();
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)({
        queryKey: [
            "orderbook-market"
        ],
        queryFn: async ()=>{
            const markets = await (0,_utils_apis_orderbook__WEBPACK_IMPORTED_MODULE_3__/* .fetchOrderbookMarkets */ .o)();
            return markets;
        },
        initialData: _root_cypress_fixtures_orderbook_markets_json__WEBPACK_IMPORTED_MODULE_2__.data,
        refetchOnWindowFocus: false,
        enabled: enabled !== null && enabled !== void 0 ? enabled : Boolean(settingsData === null || settingsData === void 0 ? void 0 : settingsData.orderbook_feature_enabled)
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (useFetchAllMarkets);


/***/ }),

/***/ 79868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _trathailoi_phoenix_orderbook_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86439);
/* harmony import */ var _hooks_use_orderbook_ids__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8307);
/* harmony import */ var _hooks_use_query_with_subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5785);
/* harmony import */ var _hooks_use_settings__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49472);
/* harmony import */ var _wallet_adapter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33618);





const useFetchMarketInfo = (marketAddress, enabled)=>{
    const { connection  } = (0,_wallet_adapter__WEBPACK_IMPORTED_MODULE_4__/* .useConnection */ .Rc)();
    const { data: settingsData  } = (0,_hooks_use_settings__WEBPACK_IMPORTED_MODULE_3__/* .useSettings */ .r)();
    const { programId , seatManagerProgramId  } = (0,_hooks_use_orderbook_ids__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    return (0,_hooks_use_query_with_subscription__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("onAccountChange", {
        queryKey: [
            "marketState",
            marketAddress,
            programId.toBase58(),
            seatManagerProgramId.toBase58()
        ],
        queryFn: async ()=>{
            if (!marketAddress) return;
            const phoenixClient = await _trathailoi_phoenix_orderbook_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Client.createWithoutConfig */ .KUN.createWithoutConfig(connection, programId, seatManagerProgramId, [
                marketAddress
            ]);
            phoenixClient.printLadder(marketAddress.toBase58());
            const marketState = phoenixClient.marketStates.get(marketAddress.toBase58());
            const baseTokenMintAddress = marketState === null || marketState === void 0 ? void 0 : marketState.data.header.baseParams.mintKey;
            const quoteTokenMintAddress = marketState === null || marketState === void 0 ? void 0 : marketState.data.header.quoteParams.mintKey;
            const result = {
                phoenixClient,
                marketState,
                baseTokenMintAddress,
                quoteTokenMintAddress
            };
            return result;
        },
        refetchOnWindowFocus: false,
        enabled: enabled !== null && enabled !== void 0 ? enabled : Boolean((settingsData === null || settingsData === void 0 ? void 0 : settingsData.orderbook_feature_enabled) && marketAddress),
        keepPreviousData: true,
        subscriptionOptions: marketAddress
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (useFetchMarketInfo);


/***/ }),

/***/ 74733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ BLACK_LIST_TOKENS_SYMBOLS; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _hooks_use_nemo_apis__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67013);
/* harmony import */ var _utils_apis_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35108);



const BLACK_LIST_TOKENS_SYMBOLS = [
    "reSOL",
    "reBNB"
];
/**
 * These token options will be used in the deposit and withdraw dialog in the assets page
 */ const useDepositTokenOptions = ()=>{
    const { data: coreTokens = [] , isLoading: isFetchingCoreTokens  } = (0,_hooks_use_nemo_apis__WEBPACK_IMPORTED_MODULE_1__/* .useFetchTopCoinList */ .PE)();
    const tokenOptions = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>coreTokens.filter((token)=>!BLACK_LIST_TOKENS_SYMBOLS.includes(token.token_symbol)).map((token)=>(0,_utils_apis_helper__WEBPACK_IMPORTED_MODULE_2__/* .toRegistryTokenInfo */ .ZO)(token)), [
        coreTokens
    ]);
    return {
        tokenOptions,
        isLoading: isFetchingCoreTokens
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useDepositTokenOptions);


/***/ }),

/***/ 8307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _solana_web3_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27632);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_use_settings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49472);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73680);




const useOrderbookIds = ()=>{
    const { data: settingsData  } = (0,_hooks_use_settings__WEBPACK_IMPORTED_MODULE_2__/* .useSettings */ .r)();
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return {
            programId: new _solana_web3_js__WEBPACK_IMPORTED_MODULE_0__.PublicKey((settingsData === null || settingsData === void 0 ? void 0 : settingsData.orderbook_program_id) || _utils_helpers__WEBPACK_IMPORTED_MODULE_3__/* .DEFAULT_ORDERBOOK_PROGRAM_ID */ .Nz),
            seatManagerProgramId: new _solana_web3_js__WEBPACK_IMPORTED_MODULE_0__.PublicKey((settingsData === null || settingsData === void 0 ? void 0 : settingsData.orderbook_seat_manager_program_id) || _utils_helpers__WEBPACK_IMPORTED_MODULE_3__/* .DEFAULT_ORDERBOOK_SEAT_MANAGER_PROGRAM_ID */ .oI)
        };
    }, [
        settingsData === null || settingsData === void 0 ? void 0 : settingsData.orderbook_program_id,
        settingsData === null || settingsData === void 0 ? void 0 : settingsData.orderbook_seat_manager_program_id
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useOrderbookIds);


/***/ }),

/***/ 72427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_base_WrappedTokensFlow_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96661);
/* harmony import */ var _components_home_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5144);
/* harmony import */ var _components_home_context_orderbook__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90804);
/* harmony import */ var _layouts_MainLayout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33509);






const Home = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(3434), __webpack_require__.e(7333), __webpack_require__.e(7375), __webpack_require__.e(2054), __webpack_require__.e(6217), __webpack_require__.e(2929), __webpack_require__.e(2107), __webpack_require__.e(7428), __webpack_require__.e(8964)]).then(__webpack_require__.bind(__webpack_require__, 14460)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(14460)
            ]
    },
    ssr: false
});
const Index = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts_MainLayout__WEBPACK_IMPORTED_MODULE_5__/* .MainLayout */ .Z, {
        hasNautilus: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_home_context__WEBPACK_IMPORTED_MODULE_3__/* .SwapProvider */ .sd, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_home_context_orderbook__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_WrappedTokensFlow_context__WEBPACK_IMPORTED_MODULE_2__/* .WrapperTokensFlowProvider */ .hf, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Home, {})
                })
            })
        })
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Index);


/***/ }),

/***/ 26110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ fetchOrderbookLookupTables; },
  "o": function() { return /* binding */ fetchOrderbookMarkets; }
});

// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(1880);
;// CONCATENATED MODULE: ./cypress/fixtures/orderbook-lookup-tables.mainnet.json
var orderbook_lookup_tables_mainnet_namespaceObject = JSON.parse('{"BboKhELy5TLk8AUqiDCfsb3gZS8NHWaS3V2nG9rXUBar":"DCoaPzp5TjptqHkWAzX6BJvg3Ai7MRCe74y3pT5c4aVi","79v1HvSAfapg6RtKrwvYweN13HxhxVxLovNc5eZsvy9C":"64TByJBbMEjnGB6zJG8TCuWmj2rHWFB1WY2snV7dhqx3","7KWYo2oAjjwPTyV1yUiHTd2fxYjoPzvJm7c6GY3MTSjx":"DRqgX8gAHSi2cZHyc1G5cRNNfhNgDykSKJPahGb6bDdc","TYJsWAUmkfZDgs6oFcJkKnuCXJZLhN9t7Em44XsVCPR":"HFV5EaKd2MWNFcKRNL4X7RXpA5XaSdkLmDBmBQ63kJKH","3Mw5ciN8xTeEivzBnRdmtdWewxsiDuYwPrbqW9Qz9S1m":"B2wWP7CYxJrP3sZqGG76hefjkJ8pbDyn4D1mUcSxCxgE","BcHeXUmmD3qRcm1fMdWHtyXCxuWpV67kpp9kSKNTwVYQ":"7RM33LewLdZ7SdqshYsVFuUwsh8voogFojAsF8STgpJ7","9jmYELw1BK8yLP3TJtuGUmue39iwnjcs3rD4micSGVeT":"FetgcKWrcT2KMHc8cUjkxmLxtP6ub2Pthy6a4DZkWL4v"}');
// EXTERNAL MODULE: ./cypress/fixtures/orderbook-lookup-tables.testnet.json
var orderbook_lookup_tables_testnet = __webpack_require__(59263);
// EXTERNAL MODULE: ./cypress/fixtures/orderbook-markets.json
var orderbook_markets = __webpack_require__(2425);
;// CONCATENATED MODULE: ./cypress/fixtures/orderbook-markets.mainnet.json
var orderbook_markets_mainnet_namespaceObject = JSON.parse('{"data":[{"market_address":"BboKhELy5TLk8AUqiDCfsb3gZS8NHWaS3V2nG9rXUBar","base_token_mint_address":"GwPQTMg3eMVpDTEE3daZDtGsBtNHBK3X47dbBJvXUzF4","quote_token_mint_address":"4Q89182juiadeFgGw3fupnrwnnDmBhf7e7fHWxnUP3S3"},{"market_address":"79v1HvSAfapg6RtKrwvYweN13HxhxVxLovNc5eZsvy9C","base_token_mint_address":"GwGh3b7iNibT3gpGn6SwZA9xZme7Th4NZmuGVD75jpZL","quote_token_mint_address":"4Q89182juiadeFgGw3fupnrwnnDmBhf7e7fHWxnUP3S3"},{"market_address":"7KWYo2oAjjwPTyV1yUiHTd2fxYjoPzvJm7c6GY3MTSjx","base_token_mint_address":"4Q89182juiadeFgGw3fupnrwnnDmBhf7e7fHWxnUP3S3","quote_token_mint_address":"2kNzm2v6KR5dpzgavS2nssLV9RxogVP6py2S6doJEfuZ"},{"market_address":"TYJsWAUmkfZDgs6oFcJkKnuCXJZLhN9t7Em44XsVCPR","base_token_mint_address":"4Q89182juiadeFgGw3fupnrwnnDmBhf7e7fHWxnUP3S3","quote_token_mint_address":"BfSYryW6Q93iUKE4uNsUtAdxQT9uU4GSVg2si3outLk1"},{"market_address":"3Mw5ciN8xTeEivzBnRdmtdWewxsiDuYwPrbqW9Qz9S1m","base_token_mint_address":"HtzrB8LihudQnWPdtK5rMnyExor8jaufXLJeKybxgBzM","quote_token_mint_address":"4Q89182juiadeFgGw3fupnrwnnDmBhf7e7fHWxnUP3S3"},{"market_address":"BcHeXUmmD3qRcm1fMdWHtyXCxuWpV67kpp9kSKNTwVYQ","base_token_mint_address":"AhDXc3sRW1xKPXwDwAmGb4JonRTka5rdSjg43owF53gg","quote_token_mint_address":"4Q89182juiadeFgGw3fupnrwnnDmBhf7e7fHWxnUP3S3"},{"market_address":"9jmYELw1BK8yLP3TJtuGUmue39iwnjcs3rD4micSGVeT","base_token_mint_address":"GvTwnAQLTdM6fMZbuGQoVj5odefCC2FsDvaMgxqZV1fi","quote_token_mint_address":"4Q89182juiadeFgGw3fupnrwnnDmBhf7e7fHWxnUP3S3"}]}');
// EXTERNAL MODULE: ./src/utils/apis/index.ts
var apis = __webpack_require__(40795);
// EXTERNAL MODULE: ./src/utils/helpers.ts
var helpers = __webpack_require__(73680);
;// CONCATENATED MODULE: ./src/utils/apis/orderbook.ts







const fetchOrderbookMarkets = async ()=>{
    const [, response] = await (0,helpers/* toResultAsync */.zM)(apis/* api.get */.h.get("orderbook/markets"));
    const fixedMarkets = constants/* isMainnet */.mC ? orderbook_markets_mainnet_namespaceObject : orderbook_markets;
    return ((response === null || response === void 0 ? void 0 : response.data) || fixedMarkets.data).filter(Boolean);
};
const fetchOrderbookLookupTables = async ()=>{
    const [, response] = await (0,helpers/* toResultAsync */.zM)(apis/* api.get */.h.get("orderbook/lookup-tables"));
    const fixedLookupTables = constants/* isMainnet */.mC ? orderbook_lookup_tables_mainnet_namespaceObject : orderbook_lookup_tables_testnet;
    return (response === null || response === void 0 ? void 0 : response.data) || fixedLookupTables;
};


/***/ }),

/***/ 59263:
/***/ (function(module) {

module.exports = JSON.parse('{"DAkTPFaX4YcC7Jf2ZbBqEREc7aYLd6pdpFiY1xzCR4F2":"E5tEdzxCJNp9ET361Se5kt3Nc1puG1PTZ3zYpWZZCwnW","FYyt3YmdT1wTCy3imJNARrJBQSxh9x3JecDtUheMCrHx":"7Ejb5cMCBtc6SYpoXv13ULGheBeQmDux3KantSmPgYpF","DTLaTHF4AN3HERzeYbf9vVugMrPHAoyKag7QN6HYomjn":"2f7PbFABojmv5J83z7ZoxNQu5kpDkHd5m5eVJk5kUDcW","sT8JrgChgSfvS9wK5BJpgGLdNFNBs2nw1BCiGF6DsaY":"FWQLw6m98m6JGtpLUucUu6rgtGved1ekJzQTDWSZeVEL"}');

/***/ }),

/***/ 2425:
/***/ (function(module) {

module.exports = JSON.parse('{"data":[{"market_address":"DTLaTHF4AN3HERzeYbf9vVugMrPHAoyKag7QN6HYomjn","base_token_mint_address":"DSodi59U9ZWRnVgP94VNnKamFybYpsqYj2iKL1jQF7Ag","quote_token_mint_address":"Afy8qEgeJykFziRwiCk6tnBbd3uzxMoEqn2GTNCyGN7P"},{"market_address":"DAkTPFaX4YcC7Jf2ZbBqEREc7aYLd6pdpFiY1xzCR4F2","base_token_mint_address":"3GyCTH5u2TgctJUs6vJTMJ51GcBEHo3WBNYfsJJ3Vw3v","quote_token_mint_address":"Afy8qEgeJykFziRwiCk6tnBbd3uzxMoEqn2GTNCyGN7P"},{"market_address":"FYyt3YmdT1wTCy3imJNARrJBQSxh9x3JecDtUheMCrHx","base_token_mint_address":"HqNYxW2MztYF8mGp2f9XN6RTE7Xk4KY8nbxAmww6fdH2","quote_token_mint_address":"Afy8qEgeJykFziRwiCk6tnBbd3uzxMoEqn2GTNCyGN7P"},{"market_address":"sT8JrgChgSfvS9wK5BJpgGLdNFNBs2nw1BCiGF6DsaY","base_token_mint_address":"CHe7TGhNzxpqiW6pdVJ2H2Mw5t7yHXTNyCfzJ1WFR5Dw","quote_token_mint_address":"Afy8qEgeJykFziRwiCk6tnBbd3uzxMoEqn2GTNCyGN7P"},{"market_address":"5yPaMiC5iUxpX4B9Yvdnk3Bt4bfFD8yAXCMUi4Uh4arD","base_token_mint_address":"So11111111111111111111111111111111111111112","quote_token_mint_address":"Afy8qEgeJykFziRwiCk6tnBbd3uzxMoEqn2GTNCyGN7P"}]}');

/***/ })

}]);